import React from 'react';
import { Link } from 'react-router-dom';
import traderbroLogo from '../assets/traderbro-logo.svg';

const Footer = () => {
  return (
    <footer className="bg-[#222425] border-t border-gray-800 relative z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 relative z-50">

        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8 mb-8 sm:mb-12">

          {/* Logo and Mission */}
          <div className="lg:col-span-3">
            <div className="flex items-center mb-4">
              <img src={traderbroLogo} alt="TraderBro" className="h-8 w-auto brightness-0 invert" />
            </div>
            <p className="text-gray-400 mb-6 leading-relaxed text-sm">
              The Autonomous Financial Intelligence Platform. Institutional-grade analysis engine with real-time delivery via Web and Mobile.
            </p>

            {/* Login CTA */}
            <Link
              to="/login"
              onClick={() => {
                if (typeof gtag !== 'undefined') {
                  gtag('event', 'click', {
                    event_category: 'dashboard_cta',
                    event_label: 'footer_cta',
                    value: 1
                  });
                }
              }}
              className="inline-flex items-center gap-2 bg-[#00DA76] hover:bg-emerald-500 text-white font-semibold px-6 py-3 rounded-xl transition-all duration-300 hover:scale-105 hover:shadow-xl shadow-lg group"
            >
              <svg className="w-5 h-5 group-hover:scale-110 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
              <span>Sign In</span>
              <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </Link>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2">
            <h3 className="text-white font-bold mb-4 text-lg">Product</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="#features"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="text-gray-400 hover:text-[#00DA76] transition-all duration-200 hover:translate-x-1 inline-block cursor-pointer"
                >
                  Features
                </a>
              </li>
              <li>
                <a
                  href="#pricing"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("pricing")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="text-gray-400 hover:text-[#00DA76] transition-all duration-200 hover:translate-x-1 inline-block cursor-pointer"
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  href="#live-activity"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("live-activity")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="text-gray-400 hover:text-[#00DA76] transition-all duration-200 hover:translate-x-1 inline-block cursor-pointer"
                >
                  Activity
                </a>
              </li>
              <li>
                <Link
                  to="/research"
                  className="text-gray-400 hover:text-[#00DA76] transition-all duration-200 hover:translate-x-1 inline-block cursor-pointer"
                >
                  Research
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div className="lg:col-span-2">
            <h3 className="text-white font-bold mb-4 text-lg">Company</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="#about"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("about")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="text-gray-400 hover:text-[#00DA76] transition-all duration-200 hover:translate-x-1 inline-block cursor-pointer"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="#technology"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("technology")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="text-gray-400 hover:text-[#00DA76] transition-all duration-200 hover:translate-x-1 inline-block cursor-pointer"
                >
                  Technology
                </a>
              </li>
              <li>
                <a
                  href="mailto:connect@traderbro.ai"
                  className="text-gray-400 hover:text-[#00DA76] transition-all duration-200 hover:translate-x-1 inline-block cursor-pointer"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div className="lg:col-span-2">
            <h3 className="text-white font-bold mb-4 text-lg">Legal</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="/privacy.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-[#00DA76] transition-all duration-200 hover:translate-x-1 inline-block cursor-pointer"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="/terms.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-[#00DA76] transition-all duration-200 hover:translate-x-1 inline-block cursor-pointer"
                >
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Information */}
          <div className="lg:col-span-3">
            <h3 className="text-white font-bold mb-4 text-lg">Contact</h3>
            <div className="space-y-3 text-gray-400 text-sm">
              <p className="font-semibold text-white">TraderBro</p>
              <p className="flex items-start gap-2">
                <svg className="w-4 h-4 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span className="leading-relaxed">
                  11086 STONE CREEK ST<br />
                  WELLINGTON FL 33449, USA
                </span>
              </p>
              <p className="flex items-center gap-2">
                <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <a href="mailto:connect@traderbro.ai" className="hover:text-[#00DA76] transition-colors">
                  connect@traderbro.ai
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © 2025 TraderBro. All rights reserved.
            </p>

            {/* Social Links */}
            <div className="flex items-center gap-6">
              <a
                href="https://x.com/traderbroai"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#00DA76] transition-all duration-300 hover:scale-110 cursor-pointer"
                aria-label="Follow TraderBro on X (Twitter)"
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              <a
                href="https://linkedin.com/company/traderbroai"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#00DA76] transition-all duration-300 hover:scale-110 cursor-pointer"
                aria-label="Follow TraderBro on LinkedIn"
              >
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
